import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    ASSIGN_CARD_TO_CARD_REF,
    CONFIRM_DISCONTINUED_CARD,
    DISMISS_CARD_REF,
    GET_ALL_CRAWL_CARD_DATA, VERIFY_CARDS,
} from "../../constant/api";
import {postCall} from "../../utils/api";

const initialState = {
    data: [],
    error: "",
    status: "idle",
    isUpdateStatus: "idle",
};

export const getCrawlCards = createAsyncThunk(
    "CrawlCard/getCrawlCards",
    async ({from_id, page = 1, per_page = 10}) => {
        try {
            const response = await postCall(`${GET_ALL_CRAWL_CARD_DATA}?page=${page}&per_page=${per_page}`,{from: from_id}, false);
            return {
                ...response,
                meta: {
                    page: response?.page,
                    per_page: response?.per_page,
                    current_page: response?.current_page,
                    total: response?.total,
                    first_page: response?.first_page,
                    last_page: response?.last_page,
                    from: response?.from,
                    to: response?.to,
                }
            };
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

export const assignCardToCardRef = createAsyncThunk(
    "CrawlCard/assignCardToCardRef",
    async ({card_id, card_ref_id}) => {
        try {
            return await postCall(ASSIGN_CARD_TO_CARD_REF,{card_id, card_ref_id}, false);
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

export const dismissCardRef = createAsyncThunk(
    "CrawlCard/dismissCardRef",
    async ({card_ref_id}) => {
        try {
            return await postCall(DISMISS_CARD_REF, {card_ref_id}, false);
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

export const confirmDiscontinuedCard = createAsyncThunk(
    "CrawlCard/confirmDiscontinuedCard",
    async ({cardId, cardData}) => {
        try {
            return await postCall(`${CONFIRM_DISCONTINUED_CARD}/${cardId}`,{...cardData, display: false, status: "Discontinued"}, false);
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

export const confirmNotDiscontinuedCard = createAsyncThunk(
    "CrawlCard/confirmNotDiscontinuedCard",
    async ({cardId, cardData}) => {
        try {
            return await postCall(`${CONFIRM_DISCONTINUED_CARD}/${cardId}`,{...cardData, display: false, status: "Not Discontinued"}, false);
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

export const verifyCards = createAsyncThunk(
    "CrawlCard/verifyCards",
    async ({from_source}) => {
        try {
            return await postCall(VERIFY_CARDS, {from_source}, true);
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

const CrawlOfferSlice = createSlice({
    name: "crawlOutlet",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCrawlCards.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getCrawlCards.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data = action.payload;
            })
            .addCase(getCrawlCards.rejected, (state, action) => {
                state.status = "failed";
                state.error = action?.error?.message || "An unknown error occurred";
            })
            .addCase(assignCardToCardRef.pending, (state) => {
                state.status = "loading";
            })
            .addCase(assignCardToCardRef.fulfilled, (state, action) => {
                state.status = "succeeded";
            })
            .addCase(assignCardToCardRef.rejected, (state, action) => {
                state.status = "failed";
                state.error = action?.error?.message || "An unknown error occurred";
            })
            .addCase(dismissCardRef.pending, (state) => {
                state.status = "loading";
            })
            .addCase(dismissCardRef.fulfilled, (state, action) => {
                state.status = "succeeded";
            })
            .addCase(dismissCardRef.rejected, (state, action) => {
                state.status = "failed";
                state.error = action?.error?.message || "An unknown error occurred";
            })
            .addCase(confirmDiscontinuedCard.pending, (state) => {
                state.status = "loading";
            })
            .addCase(confirmDiscontinuedCard.fulfilled, (state, action) => {
                state.status = "succeeded";
            })
            .addCase(confirmDiscontinuedCard.rejected, (state, action) => {
                state.status = "failed";
                state.error = action?.error?.message || "An unknown error occurred";
            })
            .addCase(confirmNotDiscontinuedCard.pending, (state) => {
                state.status = "loading";
            })
            .addCase(confirmNotDiscontinuedCard.fulfilled, (state, action) => {
                state.status = "succeeded";
            })
            .addCase(confirmNotDiscontinuedCard.rejected, (state, action) => {
                state.status = "failed";
                state.error = action?.error?.message || "An unknown error occurred";
            })
    },
});

export default CrawlOfferSlice.reducer;
